import { deepMerge } from '../../../utils/deepMerge'
import { defaultProps } from './Carousel.defaultProps'
import { CarouselProps } from './Carousel.types'

/**
 * Create a deep merge between component default props and custom props
 * @param props - new props to be merged
 * @returns
 */
export const mergeCarouselProps = (props: Partial<CarouselProps>) => {
  const carouselProps = deepMerge(defaultProps, props)
  const { itemCard = {} } = carouselProps
  const itemCardProps = deepMerge(
    {
      layout: 'condensed'
    },
    itemCard
  )
  return {
    ...carouselProps,
    itemCard: itemCardProps
  }
}
